import { render, staticRenderFns } from "./SegmentProducts.vue?vue&type=template&id=0edd62e2&scoped=true&"
import script from "./SegmentProducts.vue?vue&type=script&lang=js&"
export * from "./SegmentProducts.vue?vue&type=script&lang=js&"
import style0 from "./SegmentProducts.vue?vue&type=style&index=0&id=0edd62e2&prod&lang=scss&scoped=true&"
import style1 from "./SegmentProducts.vue?vue&type=style&index=1&id=0edd62e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd62e2",
  null
  
)

export default component.exports